import { useEffect } from "react";
import { signOut } from "@/lib/infrastructure/auth";

/**
 * Logout route. Runs the full client+server sign-out (Firebase client
 * signOut() to clear the persisted session that would otherwise auto-re-
 * authenticate, POST /api/auth/logout to clear the server cookie, then
 * redirect to /login). Without clearing the Firebase client session, the
 * login page's onAuthStateChanged silently logs the same account back in —
 * which is why navigating to /logout previously just bounced back in.
 */
export default function LogoutPage() {
  useEffect(() => {
    signOut();
  }, []);

  return (
    <div className="flex h-dvh items-center justify-center bg-background text-foreground">
      Signing out…
    </div>
  );
}
